export default __webpack_public_path__ + "static/media/Anona.06da6d95.png";